import { Component, effect, inject, input, model } from '@angular/core';
import { I18nService } from '../../../services/i18n.service';
import { UiService } from '../../../services/ui.service';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-push-notification-toggle',
  templateUrl: './push-notification-toggle.html',
  styleUrls: ['./push-notification-toggle.scss'],
  imports: [NzSwitchModule, FormsModule],
})
export class PushNotificationToggleComponent {
  settings = input.required<any>();
  loading = input<boolean>(false);
  allNotifications = input<boolean>(false);
  value = model<boolean>(false);
  reset = input<boolean>(false);

  private initialValue = false;
  public ui = inject(UiService);
  public i18n = inject(I18nService);

  constructor() {
    effect(() => {
      //const currentReset = this.reset();
      this.value.set(this.initialValue);
    });
    effect(
      () => {
        //const val = this.value();
      },
      { allowSignalWrites: true }
    );
  }

  toggleValue() {
    this.value.update((prev) => !prev);
  }
}
